import { openMemoryNode } from "@/components/layout/memory-node-navigation";
import { useCanvasStore } from "@/stores/canvas-store";
import { useProjectStore } from "@/stores/project-store";

/** The memory frame in Focus, on `nodeId` when given (the tile's links). */
export function openProjectMemory(nodeId: string | null): void {
  const { currentProject, currentSpace } = useProjectStore.getState();
  openMemoryNode({
    nodeId,
    currentProject,
    currentSpace,
    selectFrame: useCanvasStore.getState().selectFrame,
  });
}
